{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} conversations selected",
    "AGENT_SELECT_LABEL": "Select agent",
    "ASSIGN_CONFIRMATION_LABEL": "Are you sure to assign {conversationCount} {conversationLabel} to",
    "UNASSIGN_CONFIRMATION_LABEL": "Are you sure to unassign {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Go back",
    "ASSIGN_LABEL": "Assign",
    "YES": "Yes",
    "SEARCH_INPUT_PLACEHOLDER": "Search",
    "ASSIGN_AGENT_TOOLTIP": "Assign agent",
    "ASSIGN_TEAM_TOOLTIP": "Assign team",
    "ASSIGN_SUCCESFUL": "Conversations assigned successfully.",
    "ASSIGN_FAILED": "Failed to assign conversations. Please try again.",
    "RESOLVE_SUCCESFUL": "Conversations resolved successfully.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Conversations visible on this page are only selected.",
    "AGENT_LIST_LOADING": "Loading agents",
    "UPDATE": {
      "CHANGE_STATUS": "Change status",
      "SNOOZE_UNTIL": "Snooze",
      "UPDATE_SUCCESFUL": "Conversation status updated successfully.",
      "UPDATE_FAILED": "Failed to update conversations. Please try again."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assign labels",
      "NO_LABELS_FOUND": "No labels found for",
      "ASSIGN_SELECTED_LABELS": "Assign selected labels",
      "ASSIGN_SUCCESFUL": "Labels assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign labels. Please try again."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Select team",
      "NONE": "None",
      "NO_TEAMS_AVAILABLE": "There are no teams added to this account yet.",
      "ASSIGN_SELECTED_TEAMS": "Assign selected team.",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign team. Please try again."
    },
    "MERGE": {
      "TOOLTIP": "Merge conversations",
      "TITLE": "Merge Conversations",
      "DESCRIPTION": "Select a target conversation. All other selected conversations will be merged into it — their messages will be moved to the target and the source conversations will be deleted.",
      "TARGET_LABEL": "Target conversation (will be kept)",
      "SOURCES_LABEL": "Source conversations (will be deleted)",
      "SELECT_TARGET": "Select a conversation as the merge target",
      "WARNING": "Warning: This action cannot be undone. Messages from all source conversations will be moved to the target conversation and the source conversations will be permanently deleted.",
      "SUBMIT": "Merge Conversations",
      "CANCEL": "Cancel",
      "SUCCESS_MESSAGE": "Conversations merged successfully",
      "ERROR_MESSAGE": "Could not merge conversations. Please try again.",
      "CONFIRM": {
        "TITLE": "Confirm Merge",
        "DESCRIPTION": "Are you sure you want to merge {sourceCount} conversations into #{targetId}? This action cannot be undone.",
        "YES": "Yes, Merge",
        "CANCEL": "Cancel"
      }
    }
  }
}
